import React from 'react';
import Company from './Company';
import ContentView from '../../Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <Company />
        </ContentView>
    );
};
export default index;
